// extracted by mini-css-extract-plugin
module.exports = {"draggable":"dnd_draggable__0nojV","dragging":"dnd_dragging__0GbR6","dragOver":"dnd_dragOver__xXrv4"};